import { Component } from 'react';

class NotFound extends Component {
  // constructor (props) {
  //     super(props);
  // }

  render() {
    return <h2>Sorry, page doesn't exist.</h2>;
  }
}

export default NotFound;
